import React from 'react'

export default function BellIcon() {
    return (
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.92 11.275C11.912 10.423 11.334 9.177 11.334 7.858V6C11.334 3.654 9.591 1.712 7.334 1.387V0.667C7.334 0.298 7.035 0 6.667 0C6.299 0 6 0.298 6 0.667V1.387C3.742 1.712 2 3.654 2 6V7.859C2 9.178 1.422 10.423 0.408 11.281C0.149 11.503 0 11.826 0 12.167C0 12.81 0.523 13.334 1.167 13.334H12.167C12.81 13.334 13.334 12.811 13.334 12.167C13.334 11.826 13.185 11.503 12.92 11.275Z" fill="currentColor"/>
            <path d="M6.66484 16C7.87184 16 8.88184 15.14 9.11384 14H4.21484C4.44784 15.14 5.45784 16 6.66484 16Z" fill="currentColor"/>
        </svg>
    )
}
